module.exports = __webpack_public_path__ + "img/0Q3A3494_L_WoodMatted_MockedUp.ef853b44.jpg";